// extracted by mini-css-extract-plugin
module.exports = {"icon":"Connect_icon__1mD5b","info":"Connect_info__1mjEz","button":"Connect_button__1oWbb"};